import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Configuration from "../configuration";
var token = localStorage.getItem("x-access-token");




export const fetchPP = createAsyncThunk("extraction/allPP", async () => {
  const response = await fetch(Configuration.BACK_BASEURL + "extraction/allPP", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },

  });
  const extraction = await response.json();
  return extraction;
});



export const fetchPPForListe = createAsyncThunk("extraction/", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "extraction/allPPForList", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
    body: JSON.stringify(action)
  });
  const extraction = await response.json();
  return extraction;
});



export const fetchPPParMois = createAsyncThunk("extraction/", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "extraction/fetchPPParMois", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
    body: JSON.stringify(action)
  });
  const extraction = await response.json();
  return extraction;
});


export const checkProduit = createAsyncThunk("extraction/checkProduit", async (action) => {

  const response = await fetch(Configuration.BACK_BASEURL + "extraction/checkProduit", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token // Make sure 'token' is defined
    },
    body: JSON.stringify(action)
  });
  const extraction = await response.json();
  return extraction;
});


//upload BL file
export const saveFile = createAsyncThunk("extraction/saveFile", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "extraction/saveFile", {
    method: 'POST',
    headers: {
      'Accept': 'application/*',
      'x-access-token': token,
    },
    body: action
  });
  const extraction = await response.json();
  return extraction;
});



export const verifEntete = createAsyncThunk("extraction/verifEntete", async (action) => {
  // console.log(action)
  const response = await fetch(Configuration.BACK_BASEURL + "extraction/verifEntete", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
    body: JSON.stringify(action)
  });
  const extraction = await response.json();
  return extraction;
});



export const AddedExcel = createAsyncThunk("extraction/enteteAddedExcel", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "extraction/enteteAddedExcel", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
    body: JSON.stringify(action)
  });
  const extraction = await response.json();
  return extraction;
});


// for export excel
export const fetchPrixProd = createAsyncThunk("extraction/allhisPP", async (action) => {
  console.log(action)
  const response = await fetch(Configuration.BACK_BASEURL + "extraction/allhisPP", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
    body: JSON.stringify(action)
  });
  const extraction = await response.json();
  return extraction;
});



export const PPDeleted = createAsyncThunk("extraction/delete", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "extraction/delete/" + action.id, {
    method: 'DELETE',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
  });
  const extraction = await response.json();
  return extraction;
});


export const verifExistance = createAsyncThunk("extraction/verifExistance", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "extraction/verifExistance", {
      method: 'POST',
      headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'x-access-token': token
      },
      body: JSON.stringify(action)
  });
  const extraction = await response.json();
  return extraction;
});



const extractionReduce = createSlice({
  name: "extraction",
  initialState: {
    entities: [],
    loading: false,
  },
  reducers: {
  },
  extraReducers: {
  },
});


export default extractionReduce.reducer;